import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import { LocationContext } from "../context/LocationContext";
import { Link } from "react-router-dom";
import AddressPicker from "../components/AddressPicker";
import AddressAutocomplete from "../components/AddressAutocomplete";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import MapPicker from "../components/MapPicker";
import TermsAndConditions from "./TermsAndConditions";
import Swal from "sweetalert2";

export default function CheckoutPage() {
const [showTerms, setShowTerms] = useState(false);
  const navigate = useNavigate();
  const { lat, lng, address: liveAddress } = useContext(LocationContext);

  /* ---------------- STATES ---------------- */

  const [cart, setCart] = useState({ items: [] });
  const [summary, setSummary] = useState(null);

  
  const [phone, setPhone] = useState("");
const [needsManualQuote, setNeedsManualQuote] = useState(false);

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("razorpay");

  const [loading, setLoading] = useState(false);
const [rxConfirmed, setRxConfirmed] = useState({});

  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
const [manualAddress, setManualAddress] = useState("");
const [manualLat, setManualLat] = useState(null);
const [manualLng, setManualLng] = useState(null);
const [autocomplete, setAutocomplete] = useState(null);

const [useManualAddress, setUseManualAddress] = useState(false);
const [showMap, setShowMap] = useState(false);

const [tempAddress, setTempAddress] = useState("");
const [tempLat, setTempLat] = useState(null);
const [tempLng, setTempLng] = useState(null);

const finalAddress = useManualAddress ? manualAddress : liveAddress;



  /* ---------------- HELPERS ---------------- */
const needsRxFlow = cart.items.some(
  i =>
    i.is_prescription_required &&
    [
      "pending_upload",
      "waiting_decision",
      "pending_review",
      "pending_call",
      "store_pickup"
    ].includes(i.prescription_status)
);



  // Any RX item?
  const hasRx = cart.items.some(
    i => i.is_prescription_required
  );


  // ❗ Only THESE are blocked
  const hasBlockedRx = cart.items.some(
    i =>
      i.is_prescription_required &&
      ["pending_upload", "waiting_decision", "pending_review"]
        .includes(i.prescription_status)
  );


  /* ---------------- LOAD CART ---------------- */

  const loadCart = async () => {
    try {

      const res = await axiosInstance.get("/cart/");

      setCart({
        items: res.data.items || [],
        total: res.data.total_amount || 0
      });


    } catch (err) {
      console.error("Cart error", err);
    }
  };


  /* ---------------- LOAD SUMMARY ---------------- */

const loadSummary = async () => {

if (!cart.items || cart.items.length === 0) return;

// ❗ Only skip summary if PURE RX cart
const onlyRx = cart.items.every(i => i.is_prescription_required);

if (onlyRx) return;

  if (
    (!useManualAddress && !lat) ||
    (useManualAddress && !manualLat)
  ) return;

  try {

    const res = await axiosInstance.post("/checkout/preview/", {
      customer_lat: useManualAddress ? manualLat : lat,

      customer_lng: useManualAddress ? manualLng : lng,
      // ONLY send coupon if NO RX
      coupon_code: !hasRx && couponApplied
        ? couponCode.trim().toUpperCase()
        : null,
    });

    setSummary(res.data);
setNeedsManualQuote(res.data.needs_manual_quote);
  } catch (err) {
    console.error("Summary error", err);
  }
};

  /* ---------------- LOAD USER ---------------- */

  const loadUser = async () => {

    try {

      const res = await axiosInstance.get("/user-info/");
      setPhone(res.data.phone || "");
console.log("PHONE FROM API:", res.data.phone);
    } catch { }
  };


  /* ---------------- INIT ---------------- */

  useEffect(() => {
    loadCart();
    loadUser();
  }, []);

useEffect(() => {
  loadSummary();
}, [
  cart.items,   // 🔥 ADD THIS LINE
  lat,
  lng,
  manualLat,
  manualLng,
  useManualAddress
]);


  /* ---------------- GEO ADDRESS ---------------- */





const fetchManualLatLng = async (addr) => {

  if (!addr) return;

  try {

    const res = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(addr)}&key=process.env.REACT_APP_GOOGLE_PLACES_API_KEY`
    );

    const data = await res.json();

    if (data.results?.length > 0) {

      const loc = data.results[0].geometry.location;

      setManualLat(loc.lat);
      setManualLng(loc.lng);

    }

  } catch {}

};



const onLoadAuto = (autoC) => {

  setAutocomplete(autoC);

};

const onPlaceChanged = () => {

  if (autocomplete !== null) {

    const place = autocomplete.getPlace();

    const lat = place.geometry.location.lat();

    const lng = place.geometry.location.lng();

    setManualAddress(place.formatted_address);

    setManualLat(lat);

    setManualLng(lng);

    console.log("Selected:", place.formatted_address, lat, lng);

  }

};


  /* ---------------- CALL ---------------- */

  const requestCall = async (item) => {

    try {

      await axiosInstance.post("/cart/request-call/", {
        cart_item_id: item.id
      });

      await loadCart();

      Swal.fire({
  icon: "success",
  title: "Request Sent",
  text: "Pharmacist will contact you shortly"
});

    } catch {
      Swal.fire({
  icon: "error",
  title: "Action Failed",
  text: "Please try again"
});
    }
  };

  /* ---------------- COUPON ---------------- */
const applyCoupon = async () => {

  if (hasRx) {
    Swal.fire({
  icon: "warning",
  title: "Coupon Not Allowed",
  text: "Coupons are not valid on prescription medicines"
});
    return;
  }

  if (!couponCode.trim()) {
    Swal.fire({
  icon: "info",
  title: "Enter Coupon",
  text: "Please enter a valid coupon code"
});
    return;
  }

  try {

    const res = await axiosInstance.post("/checkout/preview/", {
      customer_lat: useManualAddress ? manualLat : lat,

      customer_lng: useManualAddress ? manualLng : lng,
      coupon_code: couponCode.trim().toUpperCase(),
    });

    setSummary(res.data);
    setCouponApplied(true);
setNeedsManualQuote(res.data?.needs_manual_quote || false);

    Swal.fire({
  icon: "success",
  title: "Coupon Applied",
  text: "Discount has been applied successfully"
});

  } catch (err) {

    console.error(err.response?.data || err);
    Swal.fire({
  icon: "error",
  title: "Invalid Coupon",
  text: err.response?.data?.error || "Invalid coupon code"
});
  }
};



  /* ---------------- PICKUP ---------------- */

  const handlePickup = async (item) => {

    try {

      await axiosInstance.post("/cart/item/store-pickup/", {
        item_id: item.id
      });

      await loadCart();

      Swal.fire({
  icon: "success",
  title: "Store Pickup Selected",
  text: "You can collect items from store"
});

    } catch {
      Swal.fire({
      icon: "error",
      title: "Action Failed",
      text: "Something went wrong. Please try again",
      confirmButtonColor: "#dc2626"
    });
    }
  };


const confirmUpload = (itemId) => {
  setRxConfirmed(prev => ({
    ...prev,
    [itemId]: true
  }));
};


  /* ---------------- CHECKOUT ---------------- */

  const handleCheckout = async () => {


if (!finalAddress || !phone) {
  Swal.fire({
  icon: "warning",
  title: "Missing Details",
  text: "Please fill address and phone number"
});
  return;
}


if (
  (!useManualAddress && (!lat || !lng)) ||
  (useManualAddress && (!manualLat || !manualLng))
) {
  Swal.fire({
    icon: "warning",
    title: "Location Required",
    text: "Please select your location properly from map",
  });
  return;
}




    if (!termsAccepted) {
      Swal.fire({
  icon: "warning",
  title: "Terms Required",
  text: "Please accept Terms & Conditions"
});
      return;
    }

    // ❗ Only block if truly pending
    const unconfirmed = cart.items.some(
  i =>
    i.is_prescription_required &&
    ["pending_upload", "waiting_decision", "pending_review"].includes(i.prescription_status) &&
    !rxConfirmed[i.id]
);

if (unconfirmed) {
  Swal.fire({
  icon: "info",
  title: "Prescription Required",
  text: "Please confirm prescription before proceeding"
});
  return;
}




    try {

      setLoading(true);


      /* ---------- RX ORDER ---------- */

      if (hasRx && needsRxFlow) {
        const res = await axiosInstance.post(
          "/orders/create-pending/",
          {
            customer_lat: useManualAddress ? manualLat : lat,

            customer_lng: useManualAddress ? manualLng : lng,
          }
        );

        navigate(`/requested-medicines?order=${res.data.order_id}`);
        return;
      }


      /* ---------- COD ---------- */

      if (paymentMethod === "cod") {

  await axiosInstance.post("/orders/cod/", {
    address: useManualAddress ? manualAddress : liveAddress,
    phone,
    customer_lat: useManualAddress ? manualLat : lat,
    customer_lng: useManualAddress ? manualLng : lng,
    terms_accepted: true
  });

  await Swal.fire({
  icon: "success",
  title: "Checkout Successful",
  text: "Order placed successfully. Delivery charges will be updated in notifications within 5-10 minutes.",
  confirmButtonColor: "#16a34a"
});

  // 🔥 IMPORTANT
  await loadCart();   // cart refresh

  navigate("/orders");
  return;
}


      /* ---------- ONLINE ---------- */

      const res = await axiosInstance.post("/checkout/", {
        address: useManualAddress ? manualAddress : liveAddress,

        phone,
        customer_lat: useManualAddress ? manualLat : lat,

        customer_lng: useManualAddress ? manualLng : lng,
	coupon_code: couponCode.trim().toUpperCase(),
        terms_accepted: true
      });
	if (res.data.needs_manual_quote) {

  await Swal.fire({
    icon: "info",
    title: "Delivery Charges Pending",
    text:
      res.data.message ||
       "Your order has been placed successfully.\n\n" +
  "Delivery charges will be confirmed within 5–10 minutes by admin.\n" +
  "You will be notified in app and on WhatsApp.",
  });

  await loadCart(); // optional but good

  navigate("/orders"); // 👈 IMPORTANT
  return;
}
      navigate(`/payment/${res.data.internal_order_id}`);


    } catch (err) {

      console.error(err);
      Swal.fire({
    icon: "error",
    title: "Checkout Failed",
    text: "Something went wrong. Please try again",
    confirmButtonColor: "#dc2626"
  });

    } finally {

      setLoading(false);
    }
  };





useEffect(() => {
  console.log("LAT LNG:", lat, lng);
}, [lat, lng]);

const hasPendingRx = cart.items.some(
  i =>
    i.is_prescription_required &&
    i.prescription_status !== "approved"
);
  /* ---------------- UI ---------------- */

  return (

    <div style={{ maxWidth: 800, margin: "auto", padding: 16 , paddingBottom: "120px"}}>

      <h1>Checkout</h1>


      {/* SUMMARY */}

{hasRx ? (

  <div style={{
    background: "#fff7ed",
    padding: 12,
    borderRadius: 6,
    marginBottom: 20
  }}>
    📍 Delivery location will be shared with pharmacist.
    Final delivery charges will be informed after approval.
  </div>

) : (
summary ? (

  <div
    style={{
      border: "1px solid #ddd",
      padding: 15,
      borderRadius: 8,
      marginBottom: 20,
      background: "#f9fafb"
    }}
  >

    <h2>Bill Summary</h2>

    <div style={row}>
      <span>Items Total</span>
      <span>₹{Number(summary.cart_total).toFixed(2)}</span>
    </div>




{needsManualQuote ? (
  <div style={{
    background: "#fff3cd",
    padding: "10px",
    borderRadius: "6px",
    marginTop: "10px"
  }}>
    🚚 Delivery charges will be calculated after admin confirmation.
    You will be notified before payment.
  </div>
) : (
  <div style={row}>
  <span>Delivery Charge</span>
      <span>₹{Number(summary.delivery_charge).toFixed(2)}</span>
 </div>
)}







   

    {Number(summary.discount) > 0 && (

      <div style={{ ...row, color: "green" }}>
        <span>Coupon Discount</span>
        <span>- ₹{Number(summary.discount).toFixed(2)}</span>
      </div>

    )}

    <hr />

    <div style={{ ...row, fontWeight: "bold", fontSize: 18 }}>
      <span>Total Payable</span>
      <span>₹{Number(summary.payable_amount).toFixed(2)}</span>
    </div>

    {summary.coupon && (
      <p style={{ color: "green", marginTop: 6 }}>
        ✅ Coupon Applied: {summary.coupon}
      </p>
    )}

  </div>

) : (
   <p>Select location to calculate delivery</p>
)
)}



      {/* ITEMS */}

      <h2>Your Items</h2>


      {cart.items.map(item => (

        <div key={item.id} style={box}>

          <b>{item.name}</b>

          <p>Qty: {item.quantity}</p>

          <p>₹ {item.total_price}</p>


          {/* RX SECTION */}

          {item.is_prescription_required && (

            <div style={rxBox}>

              


  {["pending_upload", "waiting_decision"].includes(
  item.prescription_status
) && (

  <>

    {/* STEP 1: Not confirmed yet */}
    {!rxConfirmed[item.id] && (

      <>
        <p>Do you have prescription?</p>

        <button
          onClick={() => confirmUpload(item.id)}
          style={primaryBtn}
        >
          ✅ [YES] Upload
        </button>

        <button
          onClick={() => requestCall(item)}
          style={greenBtn}
        >
          📞 [NO] Call Our Pharmacist
        </button>

        <button
          onClick={() => handlePickup(item)}
          style={orangeBtn}
        >
          🏪 [want to save delivery cost] 
              Visit Store
        </button>
      </>
    )}


    {/* STEP 2: Confirmed */}
    {rxConfirmed[item.id] && (

      <p style={{ color: "#2563eb", marginTop: 6 }}>
        📄 Upload after clicking Proceed
      </p>

    )}

  </>
)}



              {item.prescription_status === "pending_call" && (
                <p style={{ color: "#92400e" }}>
                  📞 Call Requested
                </p>
              )}

              {item.prescription_status === "pending_review" && (
                <p style={{ color: "#92400e" }}>
                  ⏳ Under Review
                </p>
              )}

              {["approved", "approved_by_call"].includes(
                item.prescription_status
              ) && (
                <p style={{ color: "green" }}>
                  ✅ Approved
                </p>
              )}

              {item.prescription_status === "store_pickup" && (
                <p style={{ color: "green" }}>
                  🏪 Pickup from Store
                </p>
              )}

            </div>
          )}

        </div>
      ))}




      {/* COUPON */}

      {!hasRx && (

        <>
          <h3>Coupon</h3>

          <div style={{ display: "flex", gap: 8 }}>

            <input
              value={couponCode}
              onChange={e => setCouponCode(e.target.value)}
              style={input}
            />

            <button
              onClick={applyCoupon}
              style={primaryBtn}
            >
              Apply
            </button>

          </div>
        </>
      )}








      {/* ADDRESS */}



<h3>Address</h3>

{/* CURRENT LOCATION */}

<label style={{ display: "flex", gap: 8, marginBottom: 5 }}>
  <input
    type="radio"
    checked={!useManualAddress}
    onChange={() => setUseManualAddress(false)}
  />
  Use Current Location
</label>

<input
  type="text"
  value={liveAddress || ""}
  readOnly
  placeholder="Fetching current location..."
  style={{
    ...input,
    background: useManualAddress ? "#f3f4f6" : "white"
  }}
/>
{/* MANUAL ADDRESS */}

<label style={{ display: "flex", gap: 8, marginTop: 15, marginBottom: 5 }}>
  <input
    type="radio"
    checked={useManualAddress}
    onChange={() => setUseManualAddress(true)}
  />
  Enter Address Manually
</label>

<div style={{
  background: "#fff3cd",
  padding: "10px",
  borderRadius: "6px",
  marginBottom: "10px",
  fontSize: "13px",
  color: "#92400e"
}}>
  📍 <strong>Important:</strong> Please select your address from the Google suggestions dropdown.
  After selecting, confirm your exact location on the map and press <strong>"Confirm Location"</strong>.
  Orders may fail if the address is entered manually without selection.
</div>

{/* MANUAL ADDRESS */}




{/* GOOGLE AUTOCOMPLETE INPUT */}

<AddressPicker

 value={manualAddress}

 disabled={!useManualAddress}

 onChange={(addr) => {

   setManualAddress(addr);

 }}

 onSelect={(data) => {

   setManualAddress(data.address);

   setManualLat(data.lat);

   setManualLng(data.lng);


   // auto open map
   setTempAddress(data.address);

   setTempLat(data.lat);

   setTempLng(data.lng);

   setShowMap(true);

 }}

/>
<button

disabled={!useManualAddress}

onClick={() => {

 if (!useManualAddress) return;

 setTempAddress(manualAddress);

 setTempLat(manualLat || lat);

 setTempLng(manualLng || lng);

 setShowMap(true);

}}

style={{
 padding:10,
 background: useManualAddress ? "#2563eb" : "#9ca3af",
 color:"#fff",
 border:"none",
 borderRadius:6,
 marginBottom:10,
 cursor: useManualAddress ? "pointer" : "not-allowed"
}}

>

📍 Select on Map

</button>
{showMap && (

<div>

<MapPicker

 lat={tempLat}

 lng={tempLng}

 onSelect={(data)=>{

   setTempAddress(data.address);

   setTempLat(data.lat);

   setTempLng(data.lng);

 }}

/>


<button

onClick={()=>{

 setManualAddress(tempAddress);

 setManualLat(tempLat);

 setManualLng(tempLng);

 setShowMap(false);

}}

style={{
 width:"100%",
 padding:12,
 background:"green",
 color:"#fff",
 border:"none",
 borderRadius:6
}}

>

Confirm Location

</button>

</div>

)}








      <input
        value={phone}
        onChange={e => setPhone(e.target.value)}
        style={input}
      />


      {/* TERMS */}

<label style={{ display: "flex", alignItems: "center", gap: 6 }}>

  <input
    type="checkbox"
    checked={termsAccepted}
    onChange={e => setTermsAccepted(e.target.checked)}
  />

  I agree to

<span
  onClick={() => setShowTerms(true)}
  style={{
    color: "#2563eb",
    textDecoration: "underline",
    cursor: "pointer"
  }}
>
  Terms & Conditions
</span>

{showTerms && (
  <div style={{
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.5)",
    zIndex: 999
  }}>
    <div style={{
      background: "#fff",
      margin: "40px auto",
      padding: 20,
      width: "90%",
      maxHeight: "85%",
      overflowY: "auto",
      borderRadius: 10
    }}>

      <button
        onClick={() => setShowTerms(false)}
        style={{
          float: "right",
          background: "red",
          color: "#fff",
          border: "none",
          padding: "5px 10px",
          borderRadius: 5
        }}
      >
        ✖
      </button>

      <TermsAndConditions />

    </div>
  </div>
)}

</label>


      {/* PAYMENT */}

      <h3>Payment</h3>
{hasRx && hasPendingRx && (
  <div style={{
    background: "#fff7ed",
    border: "1px solid #fdba74",
    padding: 10,
    marginBottom: 10,
    borderRadius: 6,
    color: "#9a3412"
  }}>
    🔒 Payment will be enabled once prescription is approved
  </div>
)}

      <label>
        <input
          type="radio"
          checked={paymentMethod === "razorpay"}
          disabled={hasPendingRx}
          onChange={() => setPaymentMethod("razorpay")}
        /> Online
      </label>

      <br />

      <label>
        <input
          type="radio"
          checked={paymentMethod === "cod"}
          disabled={hasPendingRx}
          onChange={() => setPaymentMethod("cod")}
        /> COD
      </label>


      {/* SUBMIT */}

{/* SUBMIT */}
<button
  onClick={handleCheckout}
  disabled={
    loading ||
    !termsAccepted
  }
  style={{
    position: "sticky",
    bottom: 0,
    width: "100%",
    padding: "12px",
    background: "#fff",
    borderTop: "1px solid #eee",
    zIndex: 10,
  }}
>
  <div
    style={{
      background:
        loading ||
        !termsAccepted 
        
          ? "#9ca3af"
          : "green",
      color: "#fff",
      padding: "14px",
      borderRadius: 8,
      textAlign: "center",
      fontWeight: "600",
    }}
  >
    {loading ? "Processing..." : "Proceed"}
  </div>
</button>

    </div>
  );
}


/* ---------------- STYLES ---------------- */

const box = {
  border: "1px solid #ddd",
  padding: 12,
  marginBottom: 10,
  borderRadius: 6
};

const input = {
  width: "100%",
  padding: 10,
  marginBottom: 10
};

const payBtn = {
  position: "sticky",
  bottom: 0,
  width: "100%",
  padding: "12px",
  background: "#fff",
  borderTop: "1px solid #eee",
  zIndex: 10,
};

const primaryBtn = {
  background: "#2563eb",
  color: "#fff",
  padding: "6px 12px",
  border: "none",
  borderRadius: 5,
  marginRight: 5,
  cursor: "pointer"
};

const greenBtn = {
  ...primaryBtn,
  background: "#16a34a"
};

const orangeBtn = {
  ...primaryBtn,
  background: "#f97316"
};

const rxBox = {
  background: "#fff3cd",
  padding: 10,
  borderRadius: 6,
  marginTop: 10,
  border: "1px solid #ffeeba"
};
const row = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 6,
};
